"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartSelection = void 0;
var Backbone = __importStar(require("backbone"));
var underscore_1 = __importDefault(require("underscore"));
var factors_1 = require("../../fixtures/factors");
var ChartSelection = /** @class */ (function (_super) {
    __extends(ChartSelection, _super);
    function ChartSelection() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getFactor = function () { return _this.get('factor'); };
        return _this;
    }
    ChartSelection.prototype.initialize = function (options) {
        this.municipalityNames = options.municipalityNames;
        this.countyNames = options.countyNames;
        this.group = options.group;
        this.set('type', 'Företagare');
        this.set('subseries', '');
        this.set('municipality', options.municipality);
        this.set('compareTo', options.compareTo);
        return this.bind('change:factor', this.fetchTopMunicipalities, this);
    };
    ChartSelection.prototype.hasIcon = function () { return underscore_1.default.includes(ChartSelection.factorsWithIcons, this.getFactor()); };
    ChartSelection.prototype.showGradingScale = function (factor) {
        var effectiveFactor = factor !== null && factor !== void 0 ? factor : this.getFactor();
        return !underscore_1.default.includes(ChartSelection.factorsWithoutGradingScale, effectiveFactor);
    };
    ChartSelection.prototype.applicableToPoliticians = function () { return !underscore_1.default.includes(ChartSelection.unapplicableToPoliticians, this.getFactor()); };
    ChartSelection.prototype.municipalities = function () {
        var municipality = this.get('municipality');
        var compareTo = this.get('compareTo');
        return [municipality].concat(compareTo);
    };
    ChartSelection.prototype.municipality = function () {
        return this.get('municipality');
    };
    ChartSelection.prototype.setMunicipality = function (name) {
        this.set('municipality', name);
        return this.set('compareTo', []);
    };
    ChartSelection.prototype.addMunicipality = function (name) {
        var _a, _b;
        if (!name) {
            return;
        }
        var region = underscore_1.default.detect((_a = this.municipalityNames) !== null && _a !== void 0 ? _a : [], function (n) { return n.toLowerCase() === name.toLowerCase(); });
        if (!region) {
            region = underscore_1.default.detect((_b = this.countyNames) !== null && _b !== void 0 ? _b : [], function (n) { return n.toLowerCase() === name.toLowerCase(); });
        }
        if (!region) {
            return;
        }
        if (region === this.get('municipality')) {
            return;
        }
        var municipalities = this.get('compareTo').slice();
        municipalities.push(region);
        municipalities = underscore_1.default.uniq(municipalities);
        return this.set('compareTo', municipalities);
    };
    ChartSelection.prototype.removeMunicipality = function (name) {
        var municipalities = this.get('compareTo').slice();
        municipalities = underscore_1.default.without(municipalities, name);
        return this.set('compareTo', municipalities);
    };
    ChartSelection.prototype.top = function () {
        return this.get('top');
    };
    ChartSelection.prototype.fetchTopMunicipalities = function () {
        var _this = this;
        var factor = this.getFactor();
        if (underscore_1.default.includes(ChartSelection.meaninglessTopFive, factor)) {
            this.set('top', null);
            return;
        }
        var query = this.group === 'survey' ?
            { type: this.get('type') }
            :
                {};
        return $.ajax("/ranking/" + factor + "/top", {
            type: 'get',
            data: query,
            success: function (data) {
                return _this.set('top', data);
            }
        });
    };
    ChartSelection.prototype.downloadAsExcel = function () {
        var municipalities = [this.get('municipality')].concat(this.get('compareTo'));
        console.log(municipalities);
        return $.ajax({
            url: '/downloads',
            type: 'post',
            dataType: 'json',
            data: {
                // 'download[type]': this.get('type'), // TODO: non-effective? See below.
                'download[municipalities][]': municipalities,
                'download[source]': this.get('type'),
                'download[type]': 'excel',
                'download[factor]': this.get('factor')
            },
            success: function (data) {
                return window.location.href = data.url;
            }
        });
    };
    ChartSelection.factorsWithIcons = ['new_entrepreneurship', 'employment_level', 'private_sector_employment', 'municipal_tax',
        'contracting', 'amount_of_business', 'services_to_businesses', 'application_of_laws',
        'competition_with_private_companies', 'roads_railways_airports', 'telecom_and_it_networks',
        'access_to_competent_labour', 'summary_evaluation', 'attitudes_public', 'attitudes_politicians',
        'attitudes_civil_servants', 'attitudes_media', 'attitudes_schools'];
    // TODO: The '.chartingArray?.[0]' stuff is real ugly... And potentially wrong. The Backbone stuff really needs to go...
    ChartSelection.unapplicableToPoliticians = factors_1.Factors.filter(function (f) { var _a, _b; return ((_b = (_a = f.chartingArray) === null || _a === void 0 ? void 0 : _a[0].factorComparison) === null || _b === void 0 ? void 0 : _b.applicableToPoliticians) === false; }).map(function (f) { return f.slug; });
    ChartSelection.meaninglessTopFive = factors_1.Factors.filter(function (f) { var _a, _b; return ((_b = (_a = f.chartingArray) === null || _a === void 0 ? void 0 : _a[0].factorComparison) === null || _b === void 0 ? void 0 : _b.singleDimensionComparable) === false; }).map(function (f) { return f.slug; });
    ChartSelection.factorsWithoutGradingScale = factors_1.Factors.filter(function (f) { var _a, _b; return ((_b = (_a = f.chartingArray) === null || _a === void 0 ? void 0 : _a[0].factorComparison) === null || _b === void 0 ? void 0 : _b.withoutGradingScale) === true; }).map(function (f) { return f.slug; });
    return ChartSelection;
}(Backbone.Model));
exports.ChartSelection = ChartSelection;
